import BlockReviewOfSystems from 'ziphy-web-shared/basic/lib/forms/builder/ui/block/blockReviewOfSystems/BlockReviewOfSystems';
import ButtonDefault from 'ziphy-web-shared/basic/lib/forms/builder/ui/button/ButtonDefault';
import { BlockElementBMI, BlockElementDefault, BlockElementFormFieldInline, BlockElementInline, } from './ui/block/BlockElement';
import { DateDefault, DateSelectDefault, GroupDefault, GroupSecondary, InputDefault, SelectDefault, TextareaDefault, ToggleButtonDefault, ToggleButtonForm, } from './ui/fields';
import { TextElementDefault, TextElementInfoText, TextElementInline } from './ui/text/TextElement';
import { TitleElementDefault, TitleElementTitle } from './ui/title/TitleElement';
export const builderTitleVariants = {
    default: {
        elementProps: {},
        Component: TitleElementDefault,
    },
    h1: {
        elementProps: {},
        Component: TitleElementTitle,
    },
    h2: {
        elementProps: {},
        Component: TitleElementTitle,
    },
    h3: {
        elementProps: {},
        Component: TitleElementTitle,
    },
    h4: {
        elementProps: {},
        Component: TitleElementTitle,
    },
    h5: {
        elementProps: {},
        Component: TitleElementTitle,
    },
    h6: {
        elementProps: {},
        Component: TitleElementTitle,
    },
};
export const builderTextVariants = {
    default: {
        elementProps: {},
        Component: TextElementDefault,
    },
    inline: {
        elementProps: {},
        Component: TextElementInline,
    },
    info_text: {
        elementProps: {},
        Component: TextElementInfoText,
    },
};
export const builderBlockVariants = {
    default: {
        elementProps: {},
        Component: BlockElementDefault,
    },
    inline: {
        elementProps: {},
        Component: BlockElementInline,
    },
    form_field_inline: {
        elementProps: {},
        Component: BlockElementFormFieldInline,
    },
    bmi: {
        elementProps: {},
        Component: BlockElementBMI,
    },
    ros: {
        elementProps: {},
        Component: BlockReviewOfSystems,
    },
};
export const builderButtonVariants = {
    default: {
        elementProps: {},
        Component: ButtonDefault,
    },
};
export const builderFieldVariants = {
    input_default: {
        elementProps: { defaultValue: 'string' },
        Component: InputDefault,
    },
    date_default: {
        elementProps: { defaultValue: 'string' },
        Component: DateDefault,
    },
    date_select_default: {
        elementProps: {
            defaultValue: 'string',
            fieldConfig: { transformIn: ['dateSelectIn'], transformOut: ['dateSelectOut'] },
        },
        Component: DateSelectDefault,
    },
    select_default: {
        elementProps: { defaultValue: 'object' },
        Component: SelectDefault,
    },
    textarea_default: {
        elementProps: { defaultValue: 'string' },
        Component: TextareaDefault,
    },
    toggle_button_default: {
        elementProps: { defaultValue: 'object' },
        Component: ToggleButtonDefault,
    },
    toggle_button_form: {
        elementProps: { defaultValue: 'object' },
        Component: ToggleButtonForm,
    },
};
export const builderGroupFieldVariants = {
    default: { elementProps: {}, Component: GroupDefault },
    secondary: { elementProps: {}, Component: GroupSecondary },
};
